import { Component, Input } from '@angular/core';
import { endOfDay } from 'date-fns';

import { AssignmentDetailsStateService } from '../../services/assignment-details-state.service';
import { AssignmentParticipantsStateService } from '../../services/assignments-participants-state.service';

@Component({
    selector: 'app-assignment-participant',
    templateUrl: './assignment-participants.component.html',
    styleUrl: './assignment-participants.component.scss'
})
export class AssignmentParticipantsComponent {
    @Input({ required: true }) assignmentId!: number;
    @Input({ required: true }) isSkillAllocationAllowed: boolean = false;
    @Input({ required: true }) isAttendanceCheckAllowed: boolean = false;

    constructor(
        protected assignmentParticipantStateService: AssignmentParticipantsStateService,
        protected assignmentDetailsStateService: AssignmentDetailsStateService
    ) { }

    protected getDeadline(isLesson: boolean, eventLessonTo: Date): Date | null {
        if (!isLesson) return null;
        return endOfDay(eventLessonTo);
    }
}
